import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid } from '@mui/material';

const FolderGeneralInfoSummary = ({ generalInfo, t }) => (
  <Grid container>
    <Grid item xs={12} sm={3}>
      <strong>{t('Folder.GeneralData.GeneralInfo.RiskResponsible')}</strong>: <span>{generalInfo.responsibleName || ''}</span>
    </Grid>
    <Grid item xs={12} sm={3}>
      <strong>{t('Folder.GeneralData.GeneralInfo.Client')}</strong>: <span>{generalInfo.client.clientName || ''}</span>
    </Grid>
    <Grid item xs={12} sm={3}>
      <strong>{t('Folder.GeneralData.GeneralInfo.FolderType')}</strong>: <span>{generalInfo.folderType || ''}</span>
    </Grid>
    <Grid item xs={12} sm={3}></Grid>
  </Grid>
);

FolderGeneralInfoSummary.propTypes = {
  generalInfo: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired
};

export default withTranslation()(FolderGeneralInfoSummary);
